import { render, staticRenderFns } from "./SmbApiAlert.vue?vue&type=template&id=00376f39&"
import script from "./SmbApiAlert.vue?vue&type=script&lang=ts&"
export * from "./SmbApiAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports